<template>
  <div class="c-keyword-interest">
    <Row>
      <Col span="15" class-name="c-keyword-box">
        <Tabs v-model="tagType" :animated="false" @on-click="changeTabPane">
          <TabPane label="意图词推荐" name="category">
            <category-select
              v-model="results"
              ref="category"
              :account="account"
              :result="results"
              @on-add="keywordAdd"
              @on-del="keyworDel"
            />
          </TabPane>
          <TabPane label="使用我的意图词包" name="keyword">
            <keyword-select
              ref="keyword"
              :data="packages"
              :loading="asyning"
              :disabled="len >= max"
              @on-sort="keywordSort"
              @on-add="keyowrdBatchAdd"
            />
          </TabPane>
          <template slot="extra">
            <el-button :disabled="len >= max" @click="batchAddModel = true"> 批量添加 </el-button>
          </template>
        </Tabs>
      </Col>
      <Col span="8" offset="1" class-name="result-box c-keyword-box">
        <div class="title">
          <span class="header-title">已选意图词（{{ len }}/{{ max }}）</span>
          <el-button class="header-clear" v-show="len" @click="$emit('on-clear')" type="text">清空全部</el-button>
        </div>
        <div class="c-search">
          <Input v-model="keyword" placeholder="请输入关键字搜索" clearable search />
        </div>
        <div v-if="len" class="result-list">
          <div class="c-body">
            <div class="list-wrap">
              <div class="list-item" v-for="(word, id) in filterData" :key="id">
                <span class="num">{{ id + 1 }}</span>
                <span class="name">{{ word }}</span>
                <span class="operate">
                  <el-button type="text" @click="$emit('on-delete', word)">删除</el-button>
                </span>
              </div>
            </div>
          </div>
          <div class="c-foot">
            <el-popover v-model="saveModel" trigger="manual" placement="top-start">
              <input-len v-model="wtpName" placeholder="意图词包名称" :max="40" :width="342" />
              <div style="margin-top: 10px">
                <ElButton type="primary" :loading="saving" @click="saveSubmit">
                  <span v-if="saving">保存中...</span>
                  <span v-else>确定</span>
                </ElButton>
                <ElButton type="default" @click="saveCancel">取消</ElButton>
              </div>

              <el-button type="text" slot="reference" @click="saveModel = true">保存为词包</el-button>
            </el-popover>
          </div>
          <!-- <div class="num-span"></div> -->
        </div>
        <div v-else class="no-data">
          <Icon type="ios-filing-outline" size="58" color="#efefef" />
          <span>暂未选择</span>
        </div>
      </Col>
    </Row>

    <!-- 批量导入 -->
    <betch-import v-model="batchAddModel" :max="max" :result="results" @on-select="batchAddWords" />
  </div>
</template>
<script>
import { isArray, isEmpty, timeout, trim, getByteLen, deepCopy } from '@/common/js/utils'

import InputLen from '@/components/input/input-len'
import CategorySelect from './select/category.vue'
import KeywordSelect from './select/keyword.vue'
import BetchImport from './select/betch-import'

import { getWtpFeed, addWtpFeedSingle } from '@/api/baidu.model'

export default {
  name: '',
  components: { InputLen, CategorySelect, KeywordSelect, BetchImport },
  props: {
    value: {
      type: Array
    },
    account: {
      type: [Number, String]
    }
  },
  computed: {
    results: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    },
    filterData() {
      const keyword = trim(this.keyword).toLowerCase()
      return this.results.filter((ret) => isEmpty(keyword) || ret.toLowerCase().includes(keyword))
    },
    max() {
      return 2000
    },
    len() {
      return isArray(this.results) && this.results.length
    }
  },
  data() {
    return {
      batchAddModel: null,
      asyning: null,
      saving: null,
      saveModel: false,
      wtpName: '',
      tagType: 'category',
      keyword: '', // 结果中过滤
      packages: [], // 排序
      wtpPackages: [] // 原始词包
    }
  },
  methods: {
    keyworDel({ keyWord }) {
      keyWord && this.$emit('on-delete', keyWord)
    },
    keywordAdd(rows) {
      if (!isArray(rows) || !rows.length) return
      if (rows.length > 1) {
        const includes = rows.filter((ret) => ret.keyWord && !this.results.includes(ret.keyWord)).map((ret) => ret.keyWord)
        includes.length && this.appendKeyWords(includes)
      } else {
        const { keyWord } = rows.pop()
        if (!keyWord) return
        const include = this.results.findIndex((met) => met === keyWord)
        include < 0 && this.appendKeyWords([keyWord])
      }
    },
    keyowrdBatchAdd({ keywords }) {
      if (!keywords) return
      const vals = keywords.split(',').filter((ret) => {
        const include = this.results.findIndex((met) => met === ret) > -1
        return !include
      })
      this.$Message.info(`批量导入意图词包成功，有效意图词  ${vals.length} 个`)
      this.appendKeyWords(vals)
    },
    batchAddWords(vals) {
      this.batchAddModel = false
      this.appendKeyWords(vals)
    },
    appendKeyWords(vals) {
      const invailen = this.max - this.len
      if (vals.length > invailen) {
        const idx = vals.length - invailen
        vals.splice(-idx, idx)
      }
      this.$emit('on-select', vals)
    },
    // 词包排序
    keywordSort({ sort, order }) {
      if (order === 'desc' && sort) {
        // hot 1 -> 高
        this.packages = deepCopy(this.wtpPackages.sort((a, b) => a.hot - b.hot))
      } else if (order === 'asc' && sort) {
        this.packages = deepCopy(this.wtpPackages.sort((a, b) => b.hot - a.hot))
      } else this.packages = deepCopy(this.wtpPackages)
    },
    changeTabPane() {
      this.$refs.category.doLayout()
      this.$refs.keyword.doLayout()
    },
    saveCancel() {
      this.saveModel = false
      timeout(500).then(() => {
        this.wtpName = ''
      })
    },
    saveSubmit() {
      if (isEmpty(this.wtpName)) {
        this.$Message.error('意图词包名称不能为空！')
        return
      } else if (getByteLen(this.wtpName) > 40) {
        this.$Message.error('意图词包名称不能超过40个字符！')
        return
      }
      this.saving = true
      addWtpFeedSingle({
        ad_account_id: this.account,
        wtpName: this.wtpName,
        keywords: this.filterData.join(',')
      })
        .then((data) => {
          this.saving = false
          if (data) {
            this.proload()
            this.wtpName = ''
            this.$Message.success('添加意图词包成功！')
            this.saveModel = false
          }
        })
        .catch(() => {
          this.saving = false
        })
    },
    proload() {
      const param = { ad_account_id: this.account }
      this.asyning = true
      Promise.all([getWtpFeed(param)])
        .then((data) => {
          this.asyning = false
          const [wtdFeeds] = data
          if (isArray(wtdFeeds)) {
            this.wtpPackages = wtdFeeds.map((ret) => {
              ret.shortKeyWords = ret.keywords.length > 500 ? `${ret.keywords.substring(0, 500)}...` : ret.keywords
              return ret
            })
            this.keywordSort({ sort: 'hotLevel' })
          }
        })
        .catch(() => {
          this.asyning = false
        })
    }
  },
  created() {
    this.proload()
  }
}
</script>
<style lang="scss" scoped>
.c-keyword-interest {
  position: relative;

  .c-keyword-box {
    padding: 10px 12px;
    border: solid 1px #dee4f5;
    border-radius: 4px;
  }

  .result-box {
    min-width: 280px;

    .title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 14px;
      line-height: 30px;

      .header-title {
        font-size: 12px;
      }

      .header-clear {
        float: right;
      }
    }

    .result-list {
      margin-top: 5px;
      position: relative;

      .c-body {
        overflow-y: auto;
        scrollbar-width: thin;
        -webkit-overflow-scrolling: touch;
        height: 470px;
        padding: 4px 0;
        border: solid 1px #dcdee2;
        border-radius: 4px;
        font-size: 12px;

        .list-item {
          display: flex;
          align-items: center;
          line-height: 22px;
          justify-content: space-between;
          &:hover {
            background-color: #f6f7fa;
            .operate {
              .el-button {
                visibility: visible;
              }
            }
          }

          .num {
            flex-basis: 30px;
            text-align: center;
          }
          .name {
            flex: 1;
            margin-left: 5px;
          }
          .operate {
            margin-right: 5px;
            .el-button {
              padding: 0;
              visibility: hidden;
            }
          }
        }
      }

      .c-foot {
        height: 26px;
        padding-top: 10px;
        font-size: 14px;
      }
    }

    .no-data {
      height: 496px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;

      span {
        color: #c1c1c1;
      }
    }
  }
}
</style>
